import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Night',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", d: "M28 17c-.61 6.61-6.47 11.56-13.08 10.95-6.61-.61-11.48-6.47-10.87-13.08C4.58 9.1 9.23 4.53 15 4c-3.07 4.15-2.27 10.01 1.88 13.08C20.19 19.52 24.7 19.44 28 17z" }
      })]
    );
  }
};